export default function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

export function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-color/src/define.js
// module id = r1gy
// module chunks = 0